import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, useHistory } from "react-router-dom";
import "aos/dist/aos.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-time-picker/assets/index.css";
import AOS from "aos";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Header from "./header";
import Footer from "./footer";
import AppRoute from "../route";
import { dashboardAction } from "../redux/action";
import Scroller from "../Component/Scroller/Scroller";
import { getAllCityFromLocal, getSelectedCity } from "../constant/utils";
import CityPopUp from "./header/PopUPCity";
import CONFIG from "../constant/config";
import { setselectedCityResponse } from "../redux/dashboard/reducer";

function Layout() {
  const dispatch = useDispatch();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [city, setCity] = useState<any>(localStorage.getItem("oq:city"));
  const [cityName, setCityName] = useState<any>(
    localStorage.getItem("oq:cityname")
  );
  // console.log("cleanedCityName", cleanedCityName);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const loader = useSelector((state: any) => state.common.loader);
  const toastData = useSelector((state: any) => state.common.toast);
  const toastId = useRef<any>(null);
  const cityData = useSelector((state: any) => state.dashboard.city);
  const cityDataAll = useSelector((state: any) => state.dashboard.cityAll);
  const [cityNotAvailable, setCityNotAvailable] = useState(false);
  // console.log("cityNotAvailable", cityNotAvailable);
  const isBookATestPage =
    window?.location?.pathname === "/book-a-test" ||
    window?.location?.pathname === "/login" ||
    window?.location?.pathname === "/checkout";

  const localCity = async () => {
    let dt = await !!getAllCityFromLocal();
    return dt;
  };
  useEffect(() => {
    if (
      !!!localStorage.getItem("oq:cityDataAll") ||
      window?.location?.pathname === "/"
    ) {
      dispatch(dashboardAction.getCityAllAction({}));
    }
    return () => {};
  }, [window?.location?.pathname]);

  useEffect(() => {
    if (cityDataAll?.length > 0) {
      localStorage.setItem("oq:cityDataAll", JSON.stringify(cityDataAll));
    }
    return () => {};
  }, [cityDataAll]);

  const getDistance = (lat1: any, lon1: any, lat2: any, lon2: any) => {
    const toRad = (value: any) => (value * Math.PI) / 180;

    const R = 6371; // Earth's radius in km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  };

  const getLan = localStorage.getItem("latitude");
  const getLon = localStorage.getItem("longitude");

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat: any = position.coords.latitude;
          const lon: any = position.coords.longitude;
          // console.log(lat, lon, "lat lon");

          // const lat: any = 30.3165;
          // const lon: any = 78.0322;

          if (!lat || !lon) {
            setCityNotAvailable(true);
          }

          const prevLat = parseFloat(localStorage.getItem("latitude") || "0");
          const prevLon = parseFloat(localStorage.getItem("longitude") || "0");

          // const prevLat = 28.6260606;
          // const prevLon = 77.3668853;
          setLocation({ latitude: lat, longitude: lon });

          const cityInfo = localStorage.getItem("oq:city") ? true : false;
          if (!cityInfo) return;

          const distance = getDistance(prevLat, prevLon, lat, lon); // will compare with the current location and the previous location (cordinates)

          if (distance > 1) {
            localStorage.setItem("latitude", lat);
            localStorage.setItem("longitude", lon);

            getLocation(lat, lon);
          }
        },
        (error) => {
          setCityNotAvailable(true);
          console.error("Error fetching location:", error);
        }
      );
    } else {
      setCityNotAvailable(true);
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    if (
      !!!localStorage.getItem("oq:cityData") ||
      window?.location?.pathname === "/"
    ) {
      dispatch(dashboardAction.getCityAction({ id: "" }));
    }
    return () => {};
  }, [window?.location?.pathname]);

  useEffect(() => {
    if (cityData?.length > 0) {
      localStorage.setItem("oq:cityData", JSON.stringify(cityData));
      const cityInfo = localStorage.getItem("oq:city") ? true : false;
      if (!cityInfo && location.latitude && location.longitude) {
        getLocation(location.latitude, location.longitude);
      }
    }
    return () => {};
  }, [cityData, location]);

  useEffect(() => {
    AOS.init();
  }, []);

  const getLocation = async (latitude: number, longitude: number) => {
    navigator.geolocation.getCurrentPosition(async (position) => {
      // const { latitude, longitude } = position.coords;

      const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=04b441516d6f454281362e12c268026c`;

      // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyD5TcEjgqPDT9teqPM6sahLpqe1r-5DMRc`;

      const resp = await fetch(url);

      const finalRespo = await resp.json();
      // console.log(finalRespo, "current");

      // const addressComponents = finalRespo.results[0]?.address_components;
      // console.log(addressComponents, "==");

      // const cityObj = addressComponents.find((component: any) =>
      //   component.types.includes("locality")
      // );

      // const cityName = cityObj?.long_name;
      // console.log("City:", cityName);

      // const currentCity = "juj";
      const currentCity =
        finalRespo.results[0].components.city ||
        finalRespo.results[0].components.town ||
        finalRespo.results[0].components.village;

      // setCity(currentCity);

      setCityName(currentCity);
      // localStorage.setItem("oq:cityname", currentCity);
      if (cityData?.length > 0) {
        const cityInfo = cityData.find(
          (item: any) =>
            item.Name?.trim().toLowerCase() ===
            currentCity?.trim().toLowerCase()
        );
        const cityId = cityInfo?.Id;
        if (!cityInfo?.Id) {
          setCityNotAvailable(true);
          alert(
            `We are not operational in your current location ${currentCity} , Please select your location`
          );
        } else {
          localStorage.setItem("oq:city", currentCity);
          setCity(cityInfo?.Id);
          // dispatch()
          dispatch(setselectedCityResponse(parseInt(cityInfo?.Id)));
        }
      }
    });
  };

  useEffect(() => {
    setShowLoader(loader);
  }, [loader]);

  useEffect(() => {
    if (toastData) {
      notify(toastData.message, toastData.type);
    }
  }, [toastData]);

  const notify = (message: string, type: any) => {
    if (!toast.isActive(toastId.current)) {
      toastId.current = toast(message, {
        type: type,
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
  };
  const SetCity = async () => {
    await localStorage.setItem("oq:city", city || "");
  };

  useEffect(() => {
    if (city) {
      SetCity();
    }
    let _city: any = getSelectedCity();
    setCity(_city);
  }, [city]);

  const setModalIsOpenToTrue = () => {
    setModalIsOpen(true);
  };
  const setModalIsOpenToFalse = () => {
    setModalIsOpen(false);
  };
  const customStyles = {
    content: {
      top: "auto%",
      left: "auto",
      right: "5%",
      bottom: "0%",
      backgroundColor: "#fff",
      minWidth: "300px",
      minHeight: "300px",
    },
  };

  useEffect(() => {
    // setCity(JSON.parse(localStorage.getItem("oq:city") || "[]"));
  }, [loader]);

  return (
    <Router>
      <Header
        cityData={cityData}
        city={city}
        setCity={setCity}
        setModalIsOpenToTrue={setModalIsOpenToTrue}
        cityName={cityName}
        setCityName={setCityName}
      ></Header>
      <main>
        <AppRoute></AppRoute>
        <Scroller></Scroller>
      </main>
      <Footer
        cityData={cityData}
        setCity={setCity}
        setModalIsOpenToTrue={setModalIsOpenToTrue}
      ></Footer>
      {isBookATestPage && (
        <CityPopUp
          cityData={cityData}
          city={city}
          setCity={setCity}
        ></CityPopUp>
      )}
      {cityNotAvailable && (
        <CityPopUp cityData={cityData} city={""} setCity={setCity}></CityPopUp>
      )}
      {/* {showLoader && <LoadingScreen/>} */}
      <ToastContainer
        theme={"colored"}
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <Modal isOpen={modalIsOpen} style={customStyles} onRequestClose={()=> setModalIsOpen(false)}>
          <div className="model-header">
          <span className="model-btn pointer" onClick={setModalIsOpenToFalse}>x</span> 
          <div className="form-group">
              <input className="form-control"/>
          </div>
          </div>
      </Modal> */}
    </Router>
  );
}

export default Layout;
